import { CheckboxUI } from '../Interface';
import { useFormikContext } from 'formik';

const OperationGroupLinks = ({ disabled }) => {
  const { values, setFieldValue } = useFormikContext();

  const updateGroupLink = (id, isChecked) => {
    const updatedLinks = values?.operationGroupLink?.map((link) =>
      link.id === id ? { ...link, checked: isChecked } : link
    );
    setFieldValue('operationGroupLink', updatedLinks);
  };

  return (
    <div>
      {values?.operationGroupLink?.map((groupLink) => (
        <div key={groupLink.id}>
          <CheckboxUI
            sx={{ margin: 0, padding: '0.2rem' }}
            disabled={disabled}
            onChange={(e) => updateGroupLink(groupLink.id, e.target.checked)}
            checked={groupLink.checked || false}
          />
          {groupLink.name}
        </div>
      ))}
    </div>
  );
};

export default OperationGroupLinks;
